/* eslint-disable @typescript-eslint/no-require-imports */
// next-i18next.config.js
/** @type {import('next-i18next').UserConfig} */
module.exports = {
  i18n: {
    defaultLocale: 'en',
    locales: ['en', 'de', 'fr', 'it', 'es'],
    localeDetection: false,
  },
  fallbackLng: 'en',
  fallbackNS: ['header', 'common', 'modals', 'footer'],
  serializeConfig: false,
  preload: true,
  lowerCaseLng: true,
  localeStructure: '{{lng}}/{{ns}}',
  detection: {
    lookupQuerystring: 'lang',
    order: ['querystring', 'cookie', 'header', 'navigator'],
    caches: ['cookie'],
    ignoreCase: true,
  },
  localePath:
    typeof window === 'undefined'
      ? require('path').resolve('./public/locales')
      : '/public/locales',
  trailingSlash: true,
};
